const containerStack = (theme) => ({
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  padding: {
    xs: '3.75rem 3rem 3rem 3rem',
    md: '3.75rem 5rem 5rem 5rem',
  },
  justifyContent: 'space-between',
  background: `linear-gradient(180deg, ${theme.palette.contrast.A700} 0%, #000 100%)`,
  gap: { xs: '2rem', md: '1rem' },
});

const leftStack = {
  minWidth: '10rem',
  gap: '0.625rem',
};

const textTypography = (theme) => ({
  color: theme.palette.neutral.A400,
  fontWeight: 500,
});

const clickableTypography = (theme) => ({
  color: theme.palette.neutral.A400,
  fontWeight: 500,
  '&:hover': {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
});

export {
  containerStack,
  leftStack,
  textTypography,
  clickableTypography,
};
